import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { coursegroupsApi } from "./coursegroupsApi";

export const useCourseGroupShopSettings = () => {
  const queryClient = useQueryClient();
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_GROUP_SHOP_SETTINGS(),
    queryFn: () => coursegroupsApi.getShopSettings(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.COURSE_GROUP_SHOP_SETTINGS() });
  };

  return { isLoading, settings: data?.data ?? [], invalidate };
};
